import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SelectedParams {
  level: number;
  topicId: number;
  difficultyId: number;
  offset: number;
  totalExercise: number;
}

interface ExerciseState {
  exerciseImage: string | null;
  searchParams: SelectedParams;
  selectedExerciseId: number;

  captureImageSessionId: string | null;
  selectedExerciseName: string | null;

  // Methods
  setParams: (params: Partial<SelectedParams>) => void;
  updateOffset: (newOffset: number) => void;
  setTotalExercise: (total: number) => void;
  resetParams: () => void;

  setSelectedExerciseId: (id: number) => void;

  setCaptureImageSessionId: (id: string) => void;
  clearCaptureImageSessionId: () => void;

  setSelectedExerciseName: (filename: string) => void;
  clearSelectedExerciseName: () => void;
}

export const useExerciseStore = create(
  persist<ExerciseState>(
    (set, get) => ({
      exerciseImage: null,
      searchParams: {
        level: 0,
        topicId: 0,
        difficultyId: 0,
        offset: 0,
        totalExercise: 0,
      },

      selectedExerciseId: 0,
      captureImageSessionId: null,
      selectedExerciseName: null,

      // Params Methods
      setParams: (params) =>
        set((state) => ({
          searchParams: {
            ...state.searchParams,
            ...params,
          },
        })),
      updateOffset: (newOffset) =>
        set((state) => ({
          searchParams: {
            ...state.searchParams,
            offset: newOffset,
          },
        })),
      setTotalExercise: (total) =>
        set((state) => ({
          searchParams: {
            ...state.searchParams,
            totalExercise: total,
          },
        })),
      resetParams: () =>
        set(() => ({
          searchParams: {
            level: 0,
            topicId: 0,
            difficultyId: 0,
            offset: 0,
            totalExercise: 0,
          },
        })),

      // Exercise ID
      setSelectedExerciseId: (id) => set({ selectedExerciseId: id }),

      // Session ID
      setCaptureImageSessionId: (id) => set({ captureImageSessionId: id }),
      clearCaptureImageSessionId: () => set({ captureImageSessionId: null }),

      // Exercise name
      setSelectedExerciseName: (filename) =>
        set({ selectedExerciseName: filename }),
      clearSelectedExerciseName: () => set({ selectedExerciseName: null }),
    }),
    {
      name: "shoonit-selected-exercise",
      storage: createJSONStorage(() => localStorage)

    }
  )
);
